/*
 * @author: chenshoyu
 * @Date: 2021-11-17 17:46:16
 */
/**
 * 模板市场-选项卡状态定义与同步
 * @author VenDream, chenqunfeng
 * @since 18/06/07
 */

import VARIABLES from 'constants/variable.json5';
import ACTIONS from 'constants/action.json5';
import { isModuleHidden } from 'utils/hidden-modules';

const initialState = {
  tabs: [
    {
      index: 0,
      name: VARIABLES.RECOMMEND,
      text: '推荐',
      hidden: isModuleHidden('recommend'),
    },
    // 合并翻页、长页为展示页
    {
      index: 1,
      name: VARIABLES.SHOWPAGE,
      text: '展示页',
    },
    // {
    //   index: 1,
    //   name: VARIABLES.RP_H5,
    //   text: '翻页',
    // },
    {
      index: 2,
      name: VARIABLES.RP_SPA,
      text: '长页',
      hidden: true,
    },
    {
      index: 4,
      name: VARIABLES.CHAJIAN,
      text: '活动玩法',
      hidden: isModuleHidden('tab-play'),
    },
    {
      index: 11,
      name: VARIABLES.POSTER,
      text: '海报',
      hidden: isModuleHidden('poster'),
    },
    // 屏蔽一视入口
    // {
    //   index: 3,
    //   name: VARIABLES.RP_VIDEO,
    //   text: '短视频',
    //   hidden: isModuleHidden('tab-video'),
    // },
    {
      index: 5,
      name: VARIABLES.RP_GAME,
      text: '小游戏',
      hidden: isModuleHidden('tab-game'),
    },
    {
      index: 6,
      name: VARIABLES.VIP,
      text: '会员专享',
      hidden: isModuleHidden('vip'),
    },
    {
      index: 7,
      name: VARIABLES.ENTERPRISE,
      text: '企业专区',
      hidden: isModuleHidden('enterprise'),
    },
    {
      index: 13,
      name: VARIABLES.OPENZONE,
      text: '平台专区',
    },
    {
      index: 8,
      name: VARIABLES.MY_TPL,
      text: '已收藏模板',
      hidden: isModuleHidden('my-tpl'),
    },
    {
      index: 9,
      name: VARIABLES.RECOMMEND,
      hidden: true,
      text: '搜索结果',
    },
    {
      index: 10,
      name: VARIABLES.OPENEDPAGE,
      // 只展示已开通的展示页模版
      text: '展示页模板',
    },
    {
      index: 12,
      name: VARIABLES.OPENEDPLUGIN,
      // 只展示 已开通的玩法模版
      text: '活动模板',
    },
  ],
  activeIndex: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_ACTIVE_TAB: {
      return { ...state, activeIndex: action.index };
    }
    default:
      return state;
  }
};
